<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title"><span class="bold">The French at Waterloo: Eyewitness Accounts</span></h1>
<p class="titleb"><span class="bold">II and VI Corps, Cavalry, Artillery, Imperial Guard and Medical Services</span></p>
<p class="author"><span class="bold">Andrew W. Field</span></p>
<div class="img_containerpa"><img alt="Image" src="images/pub.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?2b58d782